import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraEyebrow } from '../ensigns/eyebrow';
import { SpecraText } from '../ensigns/typography';
import { SpecraNavigationItemView } from '../lieutenants/navigation-item';
/** Document outline column: one navigation row per heading, with a status and an optional footer. */ export const SpecraOutlineNav = /*#__PURE__*/ React.forwardRef(({ className, emptyText, footer, items, label, renderLink, title, ...props }, ref)=>/*#__PURE__*/ _jsxs("nav", {
        "aria-label": label,
        className: cn('flex w-full flex-col gap-[var(--space-0-5)] overflow-y-auto border-b border-border px-[var(--space-3)] py-[var(--space-5-5)] md:h-full md:w-[var(--component-outline-width)] md:shrink-0 md:border-b-0 md:border-r', className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraEyebrow, {
                className: "mb-[var(--space-2)] px-[var(--space-2)]",
                children: title
            }),
            items.length ? items.map((item)=>/*#__PURE__*/ _jsx(SpecraNavigationItemView, {
                    item: {
                        ...item,
                        multiline: item.multiline ?? true
                    },
                    renderLink: renderLink
                }, item.id)) : emptyText ? /*#__PURE__*/ _jsx(SpecraText, {
                className: "px-[var(--space-2)]",
                size: "body-ui",
                tone: "muted",
                children: emptyText
            }) : null,
            footer ? /*#__PURE__*/ _jsx(SpecraText, {
                className: "mt-[var(--space-3)] px-[var(--space-2)]",
                size: "body-ui",
                tone: "muted",
                children: footer
            }) : null
        ]
    }));
SpecraOutlineNav.displayName = 'SpecraOutlineNav';
